module.exports = __webpack_public_path__ + "img/new-calendar.1edd38bf.svg";